import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import EmployeeFormLayer from "../components/EmployeeFormLayer";

const EmployeeFormPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                <EmployeeFormLayer />
            </MasterLayout>
        </>
    );
};

export default EmployeeFormPage;
